import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { GlobalSubscriptionService } from '../../subscriptions/global-subscription.service';
import { OrganizationService } from '../../organizations/organization.service';
import { Organization } from '../../shared/sdk';

@Component({
  selector: 'app-subscription-expiration-banner',
  templateUrl: './subscription-expiration-banner.component.html',
  styleUrls: ['./subscription-expiration-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionExpirationBannerComponent
  implements OnInit, OnDestroy
{
  activeOrganization: Observable<Organization>;
  ends$: Observable<number>;
  expired$: Observable<boolean>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private globalSubscriptionService: GlobalSubscriptionService,
    private orgService: OrganizationService,
  ) {}

  ngOnInit(): void {
    this.activeOrganization = this.orgService.active;

    this.ends$ = this.globalSubscriptionService.active.pipe(
      map((gs) => {
        let remaining = -1;

        if (
          gs.type === 'SI' ||
          document.location.href.includes('organizations/choose')
        ) {
          return -1;
        }

        // Expired Apollo
        if (!gs.subscription) {
          return 0;
        }

        remaining = moment(gs.dateEnd).diff(moment().startOf('day'), 'days');

        // Expired normal
        if (gs.subscription._subscriptionPlan.tier !== 0) {
          if (remaining !== 0) {
            return -1;
          }
        }

        return remaining;
      }),
      takeUntil(this.onDestroy$),
    );

    this.expired$ = this.ends$.pipe(map((ends) => ends === 0));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
